import { AxiosResponse } from 'axios';
import { FnbItemGetDto, FnbOrderGetDto, FnbOrderGetWithItemsDto, ResultDto } from 'svila-common';

import { API_URL } from '../../utils/constants';
import request from '../request';

export default {
  get: async (): Promise<AxiosResponse<any>> => {
    return request(`${API_URL}/settings`, 'get');
  },
  update: async (id: string, values: any): Promise<AxiosResponse<any>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/settings/${id}`, 'put', body);
  },
  crate: async (values: any): Promise<AxiosResponse<any>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/settings`, 'post', body);
  },
};
